import { render, staticRenderFns } from "./OrderStatus.vue?vue&type=template&id=4946168c&scoped=true"
import script from "./OrderStatus.vue?vue&type=script&lang=ts"
export * from "./OrderStatus.vue?vue&type=script&lang=ts"
import style0 from "./OrderStatus.vue?vue&type=style&index=0&id=4946168c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4946168c",
  null
  
)

export default component.exports